import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('pd-install-dismissed');
    if (dismissed) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShow(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem('pd-install-dismissed', 'true');
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 right-6 z-[9990] max-w-[280px] rounded-xl p-4 shadow-2xl"
      style={{
        background: 'rgba(10,10,10,0.95)',
        backdropFilter: 'blur(24px)',
        border: '1px solid rgba(139,92,246,0.2)',
      }}
      data-testid="pwa-install-prompt">
      <button onClick={handleDismiss} className="absolute top-2 right-2 p-1 rounded hover:bg-white/10"
        data-testid="pwa-dismiss">
        <X className="w-3.5 h-3.5 text-white/40" />
      </button>
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
          style={{ background: '#8B5CF6' }}>
          <Download className="w-4 h-4 text-white" />
        </div>
        <div>
          <p className="text-xs font-semibold text-white mb-1">Install Podcasters.Directory</p>
          <p className="text-[10px] text-white/50 mb-2">Add to your home screen for quick access</p>
          <button onClick={handleInstall}
            className="px-3 py-1.5 rounded-lg text-[10px] font-semibold text-white transition-all "
            style={{ background: '#8B5CF6' }}
            data-testid="pwa-install-btn">
            Install App
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
